var map = {
	"./melbourne.json": [
		9581,
		581
	],
	"./state-of-queensland.json": [
		2232,
		232
	],
	"./state-of-victoria.json": [
		3203,
		203
	],
	"./sydney.json": [
		8518,
		518
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3942;
module.exports = webpackAsyncContext;